var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "{t.my_initiatives}") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Dashboard---Actions",
    transform: "translate(-50.000000, -214.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Sidebar",
    transform: "translate(30.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "actions",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "icon-actions",
    transform: "translate(20.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.90444315,2.08925299 C3.19731699,3.57497471 2.15243267,5.67994372 2.00099878,7.93837936 C1.99220573,8.07883162 2.04176791,8.21668457 2.13797359,8.31936301 C2.23417928,8.42204145 2.368493,8.48043566 2.50917593,8.48074688 C2.80279543,8.47912725 3.04515585,8.25062389 3.06413089,7.95752174 C3.3574217,4.00051099 6.70182175,0.969087501 10.6672679,1.06590355 C14.6327141,1.16271959 17.8252889,4.35374279 17.9252465,8.32035467 C18.0252041,12.2869665 14.9974077,15.6348399 11.0418742,15.9313878 C10.7407809,15.952467 10.5065219,16.201619 10.5039294,16.5035324 C10.5042692,16.6404864 10.5610111,16.7712483 10.6607927,16.8650241 C10.7605743,16.9587999 10.8945767,17.0073017 11.0312429,16.9991074 C15.498583,16.7167613 18.9825502,13.018973 19,8.54135391 C19.0173191,4.06373485 15.5621701,0.33898832 11.0971571,0.0219404377 C8.84018776,-0.140448018 6.61156932,0.603531265 4.90444315,2.08925299 Z",
    id: "Path",
    fillRule: "nonzero",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.84299,3.48641546 C8.94572432,1.85669852 5.20625753,4.54967285 5.00075199,8.18491322 C4.99515171,8.25997767 5.02101626,8.33399288 5.07216204,8.38926352 C5.12330782,8.44453416 5.1951374,8.47609204 5.27047801,8.4763924 L5.60809424,8.4763924 C5.77077907,8.47512123 5.9058392,8.35050264 5.92002229,8.18857962 C6.12736269,5.10879958 9.37691897,2.87229265 12.6906957,4.42868149 C13.5145825,4.81766352 14.1788838,5.47877076 14.5714383,6.30038115 C16.1641062,9.67530677 13.8099669,12.9787375 10.6448147,13.08323 C10.5706616,13.0861511 10.511788,13.1465826 10.5108692,13.2207202 L10.5108692,13.6698548 C10.4994801,13.7548745 10.5261522,13.8405899 10.5837818,13.9041721 C10.6414113,13.9677542 10.7241469,14.0027472 10.8099531,13.9998312 C14.4576763,13.7945126 17.1567714,10.0419473 15.5017179,6.13905933 C14.9958396,4.94213131 14.041705,3.99017999 12.84299,3.48641546 Z",
    id: "Path",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.699999988,
    cx: 10.5,
    cy: 8.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "0.850051775 12.5591567 2.901609 14.5675898 0 17.4844199 1.55479301 19 4.36888599 15.9800145 6.41957302 17.9310592 9 10"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiative);
export default __webpack_public_path__ + "static/media/initiative.ab374a8c.svg";
export { ForwardRef as ReactComponent };